module.exports = __webpack_public_path__ + "static/media/ribbon.e8a4597c.jpg";